'use client';

import { URL } from '@/config/url';
import { SearchInput } from '@/shared/ui';
import { useParams, useRouter } from 'next/navigation';

export const SearchArticlesInput = () => {
  const { query } = useParams<{ query: string }>();
  const navigate = useRouter();

  const onSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const search = (data.get('search') as string) ?? '';
    navigate.push(URL.search(search));
  };

  return (
    <form onSubmit={onSearch}>
      <SearchInput placeholder="Поиск по темам..." defaultValue={query ?? ''} name="search" />
    </form>
  );
};
